import { multiplication } from "./index.js";

function getCurrentCurrency() {
  if (typeof window === "undefined" || !window.localStorage) {
    return null;
  }

  const currentCurrencyStr = window.localStorage.getItem("currentCurrency");
  if (!currentCurrencyStr) {
    return null;
  }

  try {
    return JSON.parse(currentCurrencyStr);
  } catch {
    return null;
  }
}

export function getCurrencySymbol(defaultSymbol) {
  const currentCurrency = getCurrentCurrency();
  if (currentCurrency && currentCurrency.toCurrencyCode == "CNY") {
    return defaultSymbol;
  }
  return currentCurrency &&
    (currentCurrency.shortCode ||
      currentCurrency.symbol ||
      currentCurrency.toCurrencyCode)
    ? currentCurrency.symbol ||
        currentCurrency.shortCode ||
        currentCurrency.toCurrencyCode
    : defaultSymbol;
}

export function getCurrencyNum(num) {
  const currentCurrency = getCurrentCurrency();
  if (currentCurrency && currentCurrency.toCurrencyCode == "CNY") {
    return num;
  }
  if (typeof num == "string") {
    num = Number(num);
  }
  const converted =
    currentCurrency && currentCurrency.exchangeRate && !isNaN(num)
      ? multiplication(currentCurrency.exchangeRate, num)
      : num;

  return currentCurrency?.toCurrencyCode === "TWD" && !isNaN(Number(converted))
    ? Math.round(Number(converted))
    : converted;
}
